import { render, staticRenderFns } from "./Block5.vue?vue&type=template&id=148d99b4&scoped=true"
import script from "./Block5.vue?vue&type=script&lang=js"
export * from "./Block5.vue?vue&type=script&lang=js"
import style0 from "./Block5.vue?vue&type=style&index=0&id=148d99b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d99b4",
  null
  
)

export default component.exports